// Meta (Facebook) Pixel loader + PageView tracker.

const PIXEL_ID = '931401796468747'

declare global {
  interface Window {
    fbq?: any
    _fbq?: any
  }
}

export function initMetaPixel(pixelId: string = PIXEL_ID) {
  if (typeof window === 'undefined')
    return // Official Meta Pixel base code (idempotent thanks to the f.fbq guard).
    /* eslint-disable */
  ;(function (f: any, b: Document, e: string, v: string) {
    if (f.fbq) return
    const n: any = (f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
    })
    if (!f._fbq) f._fbq = n
    n.push = n
    n.loaded = true
    n.version = '2.0'
    n.queue = []
    const t = b.createElement(e) as HTMLScriptElement
    t.async = true
    t.src = v
    const s = b.getElementsByTagName(e)[0]
    if (s && s.parentNode) {
      s.parentNode.insertBefore(t, s)
    } else {
      ;(b.head || b.body || b.documentElement).appendChild(t)
    }
  })(
    window,
    document,
    'script',
    'https://connect.facebook.net/en_US/fbevents.js',
  )
  /* eslint-enable */

  if (!(window as any).__mpPixelInitialized) {
    window.fbq('init', pixelId)
    ;(window as any).__mpPixelInitialized = true
  }

  window.fbq('track', 'PageView')
}
